import React, { useRef } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import StepIndicator from '../footer/StepIndicator'
import ModelControls from '../modelController/ModelControls'
import Pricing from '../modelController/Pricing'
import DynamicForms from '../options-forms/dynamic/DynamicForms'
import ButtonNavigation from './ButtonNavigation'
import useWindowDimensions from './useWindowDimensions'
import { MODEL_VIEWER_HOST } from '../../constants/constants'

const Body = (props) => {
   const { width } = useWindowDimensions();
   const top = useRef()

   const handleOnslid = () => {
      top.current.scrollIntoView()
   }

   let optionsForms = (
      <DynamicForms {...props} />
   )
   // min width for lg = 992
   if (width < 992) {
      optionsForms = null
   }
   return (
      <>
         <Row ref={top} style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
            <Col className='d-none d-lg-block' lg={6} >
               <Container className='d-flex flex-column vh-100  py-4 mb-lg-0 '>
                  <div style={{ flex: 'none' }}>
                     <ButtonNavigation {...props} />
                  </div>
                  <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
                     <Row>
                        <Col xs='12'>
                           {/* <OptionsTitle currentStepIndex={currentStepIndex} listData={listData} /> */}
                           {optionsForms}
                        </Col>
                     </Row>
                  </div>
                  <div style={{ flex: 'none' }}>
                     <Row>
                        <Col xs={{ span: 10, offset: 1 }} >
                           <StepIndicator {...props} handleOnslid={handleOnslid} />
                        </Col>
                     </Row>
                  </div>
               </Container>
            </Col>
            <Col lg={6} >

               <Container className='d-flex flex-column h-100 mb-lg-0 py-0 py-lg-4 text-center'>
                  <div style={{ flex: 'none' }} >
                     <Pricing {...props} />
                  </div>
                  <div style={{ flex: 1 }}>
                     <iframe id="modelFrame" title='model viewer' src={`${MODEL_VIEWER_HOST}/Azure_VR/Sample_Kilt_Configurator/-NEkf_eg41R8np4ASsS3`} style={{ border: 'none' }} allowFullScreen mozallowfullscreen="true" webkitallowfullscreen="true" allow="fullscreen; autoplay" height='100%' width='100%' ></iframe>
                  </div>
               </Container>
            </Col>
         </Row >
      </>
   )


}
export default Body
